import {
  Directive,
  HostListener,
  Input
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Directive({
    selector: "[inputLock]",
    standalone: false
})
export class InputLockDirective {
  @Input('insideModal') insideModal: boolean;
  focusInterval: any;
  constructor(
    private modalService: NgbModal,
    private matDialog: MatDialog,
  ){}
  @HostListener("focusout", ["$event"]) onFocusOut(event) {
    setTimeout(() => {
      if (!this.matDialog.getDialogById('keyboard') && (!this.modalService.hasOpenModals() || this.insideModal)) {
        event.target.focus();
      } else {
        this.focusInterval = setInterval(()=>{
          if (!this.matDialog.getDialogById('keyboard') && (!this.modalService.hasOpenModals() || this.insideModal)) {
            setTimeout(() => {
              event.target.focus();
            }, 200);
            clearInterval(this.focusInterval);
          }
        },200);
      }
    }, 200);
  }
}
